import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const notFoundEntrypoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-error-pages-not-found-entrypoint" */ './src'),
	),
	getPreloadProps: () => ({}),
});
